/**
 * Created by ChrisMuto on 7/18/17.
 */
export const TRACKED_EVENT_TRIGGERED = "TRACKED_EVENT_TRIGGERED";



// WEBPACK FOOTER //
// ./src/modules/tracker/constants.js